import type { ReactElement } from 'react';
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { COLORS } from '@garnish/constants';
import type { FocusOutlineProps } from '../Button.types';

/**
 * FocusOutline - this element contains the focus styles for the button
 */
export const FocusOutline = (props: FocusOutlineProps): ReactElement => {
  const { focusOutlineType = 'ring', focusOutlineColor = COLORS.LAVENDER } =
    props;

  const focusOutlineColorStyle = useStyle(
    () => ({ borderColor: focusOutlineColor }),
    [focusOutlineColor],
  );

  const outlineStyles = [
    styles.focusOutline,
    focusOutlineColorStyle,
    focusOutlineType === 'ring'
      ? styles.focusOutlineRound
      : styles.focusOutlineRectangular,
  ];

  return <View testID={FOCUS_OUTLINE_TEST_ID} style={outlineStyles} />;
};

// Note: the Figma definition for this is 2, but the web rendering makes it seem too close.
const OUTLINE_OFFSET_ROUND = -3;
const OUTLINE_OFFSET_RECTANGULAR = 6;

export const FOCUS_OUTLINE_TEST_ID = 'button-focus-outline-test-id';

const styles = StyleSheet.create({
  focusOutline: {
    position: 'absolute',
    borderWidth: 2,
  },
  focusOutlineRound: {
    top: OUTLINE_OFFSET_ROUND,
    left: OUTLINE_OFFSET_ROUND,
    right: OUTLINE_OFFSET_ROUND,
    bottom: OUTLINE_OFFSET_ROUND,
    borderRadius: 100, // bigger than button
  },
  focusOutlineRectangular: {
    top: OUTLINE_OFFSET_RECTANGULAR,
    left: OUTLINE_OFFSET_RECTANGULAR,
    right: OUTLINE_OFFSET_RECTANGULAR,
    bottom: OUTLINE_OFFSET_RECTANGULAR,
    borderRadius: 2,
  },
});
